const $$splitComponentImporter = () => import('/home/runner/work/inspecttec-frontend-admin/inspecttec-frontend-admin/src/routes/client/dashboard.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { Permissions } from "@/constants/permissions";
import { requirePermission } from "@/lib/auth/permission-guard";
import type { SetupStep } from "@/types/api/onboarding";
import { createFileRoute } from "@tanstack/react-router";
import { type LucideIcon } from "lucide-react";
import type { ReactNode } from "react";
export const Route = createFileRoute("/client/dashboard")({
  beforeLoad: args => requirePermission(Permissions.Clients.Impersonate, args),
  component: lazyRouteComponent($$splitComponentImporter, 'component')
});

/**
 * Client Dashboard — the landing page of client mode (founder, 2026-09-14).
 * Phase 1 shows only real data the admin API already serves: the client
 * record and its counts (`GET /clients/{id}`), go-live readiness
 * (`GET /clients/{id}/setup-status`) and held invitations. Phase 2 (open
 * issues, tagged-out assets, recent inspections) needs a new backend
 * endpoint. Replaces the placeholder with hard-coded "12 open issues" /
 * "98% compliance" and dead buttons.
 */